"use client"

import styled from "@emotion/styled"
import { sharedTheme } from "./theme/theme"

export const StyledDiv = styled.div<{ showVacationSearchButton?: boolean }>`
  ${sharedTheme.breakpoints.down("tablet")} {
    padding-top: 22px;
  }
  ${sharedTheme.breakpoints.up("tablet")} {
    padding-top: ${(p) => (p.showVacationSearchButton ? "80px" : "32px")};
  }
  ${sharedTheme.breakpoints.up("lgLaptop")} {
    padding-top: ${(p) => (p.showVacationSearchButton ? "80px" : "56px")};
  }
  ${sharedTheme.breakpoints.up("desktop")} {
    padding-top: ${(p) => (p.showVacationSearchButton ? "100px" : "56px")};
  }
`

export const StyledImageWrapper = styled.div<{
  $url?: string
}>`
  position: relative;
  width: 100%;
  height: 402px;
  background-image: url(${(p) => p.$url});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  ${sharedTheme.breakpoints.up("tablet")} {
    height: auto;
    min-height: 400px;
    padding-top: 29.5px;
    padding-bottom: 29.5px;
    padding-left: 20px;
    display: grid;
    grid-template-columns: 418px 1fr;
    gap: 40px;
  }
`
